<template>
  <div id="cesium-container" ref="cesiumContainer">
    <cesium-recorder ref="cesiumRecorder" />
    <v-text-field
      ref="altitudeInput"
      horizontal
      label="
        Altitude for visualization
        "
      v-show="!nominalAltitude"
      v-model="displayAltitude"
      style="display: inline-flex"
    />
  </div>
</template>

<script>
import { CesiumInitialization } from '../../components/ThreeD/CesiumInitialization'
import CesiumRecorder from '../../components/ThreeD/CesiumRecorder.vue'
import { Payload } from '../../components/ThreeD/Payload'

export default {
  name: 'payload-cesium-viewer',
  mixins: [CesiumInitialization, Payload],
  props: ['computedPayload', 'nominalAltitude'],
  components: {
    'cesium-recorder': CesiumRecorder
  },

  data() {
    return { displayAltitude: 600 }
  },

  watch: {
    computedPayload: {
      handler() {
        this.altitude = this.nominalAltitude
          ? parseFloat(this.nominalAltitude) * 1e3
          : parseFloat(this.displayAltitude) * 1e3
        this.createSensorEntity(this.getFormatedInputs())
      },
      deep: true
    },
    displayAltitude() {
      this.$emit('updatedDisplayAltitude', this.displayAltitude)
    }
  },

  mounted() {
    this.initializeViewer()
    this.initPayloadPC()
    this.insertElementInToolbar(this.$refs.cesiumRecorder.$el)
    this.insertElementInToolbar(this.$refs.altitudeInput.$el)
  },

  beforeDestroy() {
    this.removeSensor()
  },
  methods: {
    getFormatedInputs() {
      return {
        shape: this.computedPayload.fieldOfViewType,
        alongTrackSVA: parseFloat(
          this.computedPayload.semiViewAngleAlongTrackOperatingAltitude
        ),
        crossTrackSVA: parseFloat(
          this.computedPayload.semiViewAngleCrossTrackOperatingAltitude
        )
      }
    }
  }
}
</script>

<style scoped>
#cesium-container {
  position: relative;
  height: 500px;
  width: 100%;
  z-index: 999;
}
label {
  left: 10px;
  position: absolute;
  width: max-content;
  bottom: 10px;
}

#cesium-container >>> .v-slider--vertical,
#cesium-container >>> .v-slider__track-container {
  height: calc(0.9 * 500px) !important;
}
</style>
